module.exports = __webpack_public_path__ + "static/media/bhb_reading.5346a207.vtt";